import React from 'react';

const EkaPortfolioApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/eka.html"
        title="Eka Portfolio App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default EkaPortfolioApp;